import { I18n } from "@/i18n/I18n";
import { X } from "lucide-react";
import { Modal } from "react-bootstrap";
import { FilePreviewContent } from "./FilePreviewContent";
import { File } from "@/backend/models/file";

export function FilePreviewModal(props: { file: File, onHide: () => void }) {
  const { file, onHide } = props;

  return (
    <Modal show onHide={onHide} size="xl" contentClassName="file-preview-modal">
      <Modal.Body>
        <div className='d-flex gap-2 mb-2'>
          <button className="fusa-btn-medium-icon file-preview-close-btn" onClick={onHide} aria-label={I18n.get('close')}>
              <X size={20} />
          </button>
          <span className="file-preview-sidebar-filename">{file.fileName}</span>
        </div>
        <FilePreviewContent file={file} />
      </Modal.Body>
    </Modal>
  );
}
